import { render, staticRenderFns } from "./standardorder.vue?vue&type=template&id=f429b058"
import script from "./standardorder.vue?vue&type=script&lang=js"
export * from "./standardorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports